import { render, staticRenderFns } from "./NewsCategoryList.vue?vue&type=template&id=62e09724&scoped=true&"
import script from "./NewsCategoryList.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./NewsCategoryList.vue?vue&type=style&index=0&id=62e09724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e09724",
  null
  
)

export default component.exports